import { render } from "./Breaches.vue?vue&type=template&id=2666b301&scoped=true"
import script from "./Breaches.vue?vue&type=script&lang=js"
export * from "./Breaches.vue?vue&type=script&lang=js"

import "./Breaches.vue?vue&type=style&index=0&id=2666b301&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2666b301"]])

export default __exports__